import React from "react";
import { ChevronLeft } from "lucide-react";

export default function ProgressHeader({ index, total, onBack }) {
  const pct = (index / total) * 100;
  return (
    <div className="pt-6 px-6">
      <div className="flex items-center justify-between">
        <button
          data-testid="step-back"
          onClick={onBack}
          className="inline-flex items-center gap-1 text-[13px] text-[#6B6B6B] hover:text-[#1A1A1A] ss-focus transition-colors -ml-1"
        >
          <ChevronLeft size={18} strokeWidth={1.5} /> Back
        </button>
        <span className="font-mono-ss text-xs text-[#6B6B6B]">
          {index} / {total}
        </span>
      </div>
      <div className="mt-3 h-[2px] w-full bg-[#EBE9E4] rounded-full overflow-hidden">
        <div
          className="h-full bg-[#C9A227] transition-all duration-300"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
